import { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Col, Drawer, Form, Input, Modal, Row, Space, Spin, message } from "antd";
import { callCreatePodcast } from "../../../../config/api";

const AddPodcast = (props: any): JSX.Element => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm();
  const showModal = () => {
    setOpen(true);
  };

  const onFinish = async (values: any) => {
    setLoading(true)
    const result = await callCreatePodcast(values);
    if (result.statusCode === 201) {
      setOpen(false);
      props.handleFetchPodcast();
      message.success("create category success !");
    } else {
      message.error("create category failed !");
    }
    setLoading(false)
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <Spin spinning={loading}>
      <Button type="primary" onClick={showModal} icon={<PlusOutlined />}>
        Thêm mới
      </Button>
      <Modal
        title="Thêm podcast mới"
        open={open}
        onOk={() => {
          form.submit();
        }}
        okText="Tạo mới"
        cancelText="Hủy"
        maskClosable={false}
        width={840}
        onCancel={onClose}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true, message: "Please enter Name" }]}>
                <Input placeholder="Please enter title" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="urlPodcast"
                label="URL Podcast"
                rules={[{ required: true, message: "Please enter Image" }]}>
                <Input placeholder="Please enter Image" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="image"
                label="Image"
                rules={[{ required: true, message: "Please enter Image" }]}>
                <Input placeholder="Please enter Image" />
              </Form.Item>
            </Col>
          </Row>

          
        </Form>
      </Modal>
    </Spin>
  );
};

export default AddPodcast;
